import { createApp } from "vue";

import Axios from "axios";
import DataWebConfig from "@PrivateArea/Scripts/Config/DataWebConfig";
import AppConfig from "@PrivateArea/Scripts/Config/AppConfig";
import { router } from "@PrivateArea/Scripts/Config/RouteConfig";
import { store } from "@PrivateArea/Scripts/Config/StoreConfig";
import Localizer from "@Scripts/Common/Localizer";
import CookieHelper from "@Scripts/Infrastructure/CookieHelper";

export default class BasePage {
    public static async init() {
        await Localizer.init({
            defaultCulture: (<any>window).App.culture,
            resourceContexts: ["Account", "App", "CookieToast", "PrivateArea"]
        });

        this.initRequestVerificationToken();

        const app = createApp({});
        (<any>app).config.devtools = false;

        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            app.use(DataWeb.default);
            app.use(DataWebConfig);

            DataWeb.default.registerRoutes(router);
            DataWeb.default.registerStoreModules(store);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });
        }

        app.use(router).use(store).use(AppConfig);

        (<any>window).App.instances.vm = app.mount('#app');

        this.resetCssAnimations();
        this.setCloseInfoToast();
        this.setMenuMobile();
        this.setProjectAssociationVisible();
    }

    private static initRequestVerificationToken() {
        const antiforgerytoken = (<any>document.getElementsByName("__RequestVerificationToken")[0]).value;
        if (antiforgerytoken) {
            Axios.defaults.headers.common["RequestVerificationToken"] = antiforgerytoken;
        }
    }

    private static resetCssAnimations() {
        // Styles animations reset
        (<any>window).addEventListener("load", function () {
            let loaders = document.getElementsByClassName("loader");
            for (let i = 0; i < loaders.length; i++) {
                loaders[i].classList.add("hide");
            }

            let preLoaders = document.querySelectorAll("[data-preload]");
            for (let i = 0; i < preLoaders.length; i++) {
                preLoaders[i].removeAttribute("data-preload");
            }
        });
    }

    private static setCloseInfoToast() {
        let closeInfoToast = document.getElementsByClassName("close-info-toast")[0];
        let infoToast = document.getElementsByClassName("info-toast")[0];

        if (closeInfoToast) {
            closeInfoToast.addEventListener("click", function () {
                CookieHelper.setCookie("tst", "1", null);
                infoToast.classList.add("hden");
            });
        }
    }

    private static setMenuMobile() {
        var menuButton = document.getElementsByClassName("menu-button")[0],
            header = document.getElementsByClassName("app-header")[0],
            scrim = document.getElementsByClassName("scrim")[0];

        if (menuButton) {
            menuButton.addEventListener("click", function () {
                header.classList.add("show");
            });

            scrim.addEventListener("click", function () {
                header.classList.remove("show");
            });
        }
    }

    public static updateAutospin() {
        let button = document.querySelector("[data-autospin]");

        button?.addEventListener("click", function () {
            let iframe = document.getElementById('sketchfab-iframe') as HTMLIFrameElement;
            if (iframe) {
                let src = iframe.src;

                const url = new URL(src);
                const params = new URLSearchParams(url.search);
                const autospin = params.get('autospin');

                url.searchParams.set('autospin', autospin == '1' ? '0' : '1');

                iframe.src = url.toString();
                if (autospin == "1") {
                    button.classList.add("pause")
                    button.classList.remove("play")
                }
                else {
                    button.classList.add("play")
                    button.classList.remove("pause")
                }
            }
        });
    }

    private static setProjectAssociationVisible() {
        let assetShareButton = document.getElementById("ProjectAssociationButton");
        let body = document.getElementsByTagName("body")[0];

        if (assetShareButton) {
            assetShareButton.addEventListener("click", function () {
                (<any>window).App.instances.vm.$store.commit("projectAssociationStore/setIsProjectAssociationVisible", true);

                if (!body.hasAttribute("data-overflow")) {
                    body.setAttribute("data-overflow", "");
                }
            });
        }
    }

}